export enum CrudViewFormItemType {
  Alert = 'alert',
  AssetPicker = 'asset-picker',
  Button = 'button',
  CheckBox = 'checkbox',
  CheckboxList = 'checkbox-list',
  CheckboxTable = 'checkbox-table',
  Code = 'code',
  CodeMirror = 'codemirror',
  MonacoCodeEditor = 'monaco-code-editor',
  Date = 'date',
  DateTime = 'datetime',
  DatePicker = 'date-picker',
  DateTimePicker = 'datetime-picker',
  HTMLEditor = 'html-editor',
  Label = 'label',
  List = 'list',
  TextArea = 'textarea',
  TextBox = 'textbox',
  Number = 'number',
  TagBox = 'tag-box',
  Image = 'image',
  ImageUpload = 'image-upload',
  Rate = 'rate',
  RowForm = 'row-form',
  Select = 'select',
  TagInput = 'tag-input',
  Slider = 'slider',
  Radio = 'radio',
  RichTextEditor = 'rich-text-editor',
  InputValidatorInfo = 'input-validator-info',
  Object = 'object',
  StringArray = 'string-array',
  ColorPicker = 'color-picker',
  DimensionSelect = 'dimension-select',
  TimePicker = 'time-picker',
  EditFormConfigInput = 'edit-form-config-input',
  JsonArray = 'json-array',
  ListGridConfigInput = 'list-grid-config-input',
  ListGridDataInput = 'list-grid-data-input',
  IconPicker = 'icon-picker',
  RadioGroup = 'radio-group',
  LabelFunction = 'label-function',
  InputTemplate = 'input-template',
  Switch = 'switch',
  RowSelect = 'row-select',
  InlineRowForm = 'inline-row-form',
  IconPickerTwo = 'icon-picker-two',
  BorderSettings = 'border-settings',
  ShadowSettings = 'shadow-settings',
  Spacing = 'spacing',
  GridBuilder = 'grid-builder',
  PhoneNumber = 'phone-number-input',
  FormBuilder = 'form-builder',
  SelectCard = 'select-card',
  TreeSelect = 'tree-select',
  DocumentUpload = 'document-upload',
  Previewer = 'previewer',
  JsonInput = 'json-input',
  InputGroup = 'input-group',
  IconPickerTwoWrapper = 'icon-picker-two-wrapper'
}
